/** 页面信息 */
const page = new (function () {
  this.title = '首页'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_home'
  /**菜单编号 */
  this.code = 'penalize_home'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/penalize/home'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./dashboard.vue'),
  cache: true
}

export default page
